// Fragt den AKTUELLEN Serverstatus eines Übergabeprotokolls ab — gemeinsam genutzt von
// UebergabeListe.tsx (Route öffnen, "Jetzt senden") und UebergabeAssistent.tsx
// (abschliessen()), damit beide denselben, immer aktuellen Stand prüfen.
//
// Fix-Runde 2 (kritischer Review-Fund): vorher hatte NUR die Liste eine solche Prüfung,
// und selbst dort kannte sie nur 'abgeschlossen' — ein zwischenzeitlich abgebrochenes
// Protokoll ließ sich im Assistenten unbemerkt trotzdem fertig abschließen (PDF erzeugt,
// Mails an Mieter/Eigentümer verschickt), weil abschliessen() den Serverstatus vor dem
// Hochladen überhaupt nicht prüfte. Beide Stellen nutzen jetzt dieselbe Abfrage +
// denselben Endgültigkeits-Begriff (lib/uebergabe/listenzeilen.ts istEndgueltig).
import { supabase } from '../supabase/client';
import type { ProtokollStatus } from './typen';

/** Liefert null, wenn die Zeile nicht (mehr) existiert oder die Abfrage fehlschlägt — der Aufrufer entscheidet, wie er damit umgeht (fail open, wie überall sonst in diesem Modul). */
export async function holeServerStatus(protokollId: string): Promise<ProtokollStatus | null> {
  const { data } = await supabase.from('uebergabeprotokolle').select('status').eq('id', protokollId).maybeSingle();
  return (data?.status as ProtokollStatus | undefined) ?? null;
}
